import { render } from "./DocumentationMenu.vue?vue&type=template&id=1e12b30c"
import script from "./DocumentationMenu.vue?vue&type=script&lang=js"
export * from "./DocumentationMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__